// extracted by mini-css-extract-plugin
export var option = "_5l-0";
export var optionCard = "_5l-f";
export var optionContent = "_5l-g";
export var optionIcon = "_5l-i";
export var optionIconBox = "_5l-h";
export var optionLabel = "_5l-j";
export var optionPill = "_5l-m";
export var optionPillBadge = "_5l-p";
export var optionPillIcon = "_5l-n";
export var optionPillLabel = "_5l-o";
export var optionRadio = "_5l-k";
export var optionRadioInner = "_5l-l";
export var optionReveal = "_5l-2";
export var optionRevealDelay0 = "_5l-3";
export var optionRevealDelay1 = "_5l-4";
export var optionRevealDelay10 = "_5l-d";
export var optionRevealDelay11 = "_5l-e";
export var optionRevealDelay2 = "_5l-5";
export var optionRevealDelay3 = "_5l-6";
export var optionRevealDelay4 = "_5l-7";
export var optionRevealDelay5 = "_5l-8";
export var optionRevealDelay6 = "_5l-9";
export var optionRevealDelay7 = "_5l-a";
export var optionRevealDelay8 = "_5l-b";
export var optionRevealDelay9 = "_5l-c";
export var optionSelected = "_5l-1";